import React from 'react';
import { Flex } from '@procore/core-react';

interface DescriptionWithIconsProps {
  icon: React.ReactNode;
  textComponent: React.ReactNode;
  descriptionWithIconStyle?: string;
}

const DescriptionWithIcon = ({
  icon,
  textComponent,
  descriptionWithIconStyle,
}: DescriptionWithIconsProps) => {
  return (
    <Flex
      justifyContent="flex-start"
      alignItems="center"
      className={descriptionWithIconStyle}
    >
      {icon}
      {textComponent}
    </Flex>
  );
};

export default DescriptionWithIcon;
